import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
function StartTime(props) {
  const [valueHour, setValueHour] = useState(0);
  const [valueMinute, setValueMinute] = useState(0);
  // useEffect(
  //   () => {
  //     returnValue();
  //   },
  //   [valueHour, valueMinute]
  // );
  const changeMinutes = (value) => {
    setValueMinute(value);
    props.minuteOnly
      ? props.returnValue({ minutes: value })
      : props.returnValue({ minutes: value, hours: valueHour });
  };
  const changeHours = (value) => {
    setValueHour(value);
    !props.minuteOnly &&
      props.returnValue({ minutes: valueMinute, hours: value });
  };
  return (
    <div style={{ marginTop: 20 }}>
      <FormControl
        component="fieldset"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <FormLabel component="legend">Start time</FormLabel>
        {!props.minuteOnly && (
          <>
            <TextField
              label="Hour"
              value={valueHour}
              onChange={(e) =>
                e.target.value <= 23 &&
                e.target.value >= 0 &&
                changeHours(e.target.value)
              }
              type="number"
              margin="none"
            />
            <strong
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ height: "100%" }} />
              <div>&nbsp; : &nbsp;</div>
              <div />
            </strong>
          </>
        )}
        <TextField
          label="Minute"
          value={valueMinute}
          onChange={(e) =>
            e.target.value <= 59 &&
            e.target.value >= 0 &&
            changeMinutes(e.target.value)
          }
          type="number"
          margin="none"
        />
      </FormControl>
    </div>
  );
}

export default StartTime;
